import React, {PropsWithChildren} from "react"
import {Box} from "@mui/material"
import stanchions from "../../icon/closed-background.svg"

function ClosedGraphic({children}: PropsWithChildren<{}>) {
  return (
    <Box
      sx={{
        position: "relative",
        maxWidth: 418,
        maxHeight: 293,
        mx: "auto",
        pb: "40px",
        zIndex: 10,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "48%",
          mt: "-12px",
          ml: "-27px",
          zIndex: -1,
          transformOrigin: "top center",
          animation: "swing 2s ease-in-out infinite",
          "@keyframes swing": {
            "0%": {transform: "rotate(4deg)"},
            "50%": {transform: "rotate(-4deg)"},
            "100%": {transform: "rotate(4deg)"},
          },
        }}
      >
        {children}
      </Box>
      <Box component="img" src={stanchions} alt="" sx={{width: "100%"}}/>
    </Box>
  )
}

export default ClosedGraphic
